import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MobileMenuList extends ThemeComponent {
    @Prop links!: ShopifyLinklist[];
    @Prop id!: string;
    @Prop master!: boolean;
    @Prop({default: 'null'}) returnToId!: string;
    @Prop({default: 'null'}) returnToTitle!: string;
    @Prop({default: 'null'}) heading!: string;

    @Ref({required: false}) mobileMenuListTrigger!: HTMLButtonElement[];

    init() {

        // Init child trigger click event listener
        if (this.mobileMenuListTrigger) {
            for (const trigger of this.mobileMenuListTrigger) {
                this.$listen(trigger, 'click', (event) => {
                    // Do not complete animation of sub-child if <a></a> was clicked
                    if (event.target) {
                        const clickedElement = event.target as HTMLElement;
                        if (clickedElement.tagName === 'A') {
                            return;
                        }
                    }
                    this.handleListTrigger(trigger);
                });
            }
        }
    }

    handleListTrigger(element: HTMLButtonElement) {
        // Get ID of list to show
        const idToShow = element.getAttribute('data-target-list-id');

        // Get list
        const listToShow = document.getElementById(`${idToShow}`);
        if (!listToShow) {
            this.$log.error(`List with id: ${idToShow} could not be found`);
            return;
        }

        // Remove all active classes
        const activeLists = document.querySelectorAll('.mobile-menu-list--active');
        for (const list of activeLists) {
            // Do not remove class for parent
            if (list.contains(listToShow)) {
                continue;
            }

            // Remove class
            list.classList.remove('mobile-menu-list--active');
        }

        // Add active class
        if (listToShow) {
            listToShow.classList.add('mobile-menu-list--active');
        }
    }
}
